import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

//import tags
import { Link } from 'react-router-dom';

// import resources
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

// //import api
import FetchData from '../../../api/Api';

export default function OrderItems() {

    //get locale
    const { locale } = useParams();

    //get data
    const [data, setData] = useState(null);

    useEffect(() => {

        if (data === null) {
            const fetchData = async () => {
                try {
                    const fetchDataInstance = new FetchData();
                    await fetchDataInstance.initHeaders(locale, localStorage.getItem('token'));
                    const result = await fetchDataInstance.get(`/api/orders`, true);
                    setData(result);
                } catch (error) {
                    console.error("Failed to get data:", error.message);
                }
            };

            
            setTimeout(function() {
                fetchData();   
            }, 200)
        }

    }, [data, locale]);

    useEffect(()=> {
        setData(null);
    }, [locale])

    
    return (

        data === null ? 
            <>
                {[...Array(2)].map((_, index) => (
                    
                    <tr className="border-b" key={index}>
                        <td className="px-6 py-3 text-sm text-gray-800"><Skeleton baseColor="#f2f2f7" highlightColor="#fff" borderRadius={12} /></td>
                        <td className="px-6 py-3 text-sm text-gray-800"><Skeleton baseColor="#f2f2f7" highlightColor="#fff" borderRadius={12} /></td>
                        <td className="px-6 py-3 text-sm text-gray-800"><Skeleton baseColor="#f2f2f7" highlightColor="#fff" borderRadius={12} /></td>
                        <td className="px-6 py-3 text-sm text-gray-800"><Skeleton baseColor="#f2f2f7" highlightColor="#fff" borderRadius={12} /></td>
                    </tr>
                ))}
            </>
        :
        (
           data.data.map((item, index) => (
                // <div
                //     key={index}
                //     className="group border border-gray-150 col-span-12 md:col-span-6 lg:col-span-3 p-5 text-center shadow-lg hover:shadow-none rounded-xl duration-500"
                // >
                //     {/* <Link to={`/${locale}/news/${item.slug || ""}`}>
                //         <img
                //             className="w-full h-48 object-cover rounded-xl"
                //             src={`${process.env.REACT_APP_API_URL}/storage/uploads/news/thumbs/large_${item.img}`}
                //             alt={item.translations?.[0]?.title || "No title"}
                //         />
                //         <div className="p-4">
                //             <p className="text-[12px] md:text-[13px] lg:text-sm text-gray-500">{formatDate(item.updated_at)}</p>
                //             <h2 className="mt-2 text-[14px] md:text-[15px] lg:text-lg font-semibold text-gray-800 hover:text-[var(--orange)] transition-colors">
                //                 {item.translations?.[0]?.title || "No title"}
                //             </h2>
                //         </div>
                //     </Link> */}

                    
                // </div>

                <tr className="border-b" key={index}>
                    <td className="px-6 py-3 text-sm text-gray-800">{item.order_number}</td>
                    <td className="px-6 py-3 text-sm text-gray-800">{item.payment}</td>
                    <td className="px-6 py-3 text-sm text-gray-800">{item.payment_statust}</td>
                    <td className="px-6 py-3 text-sm text-gray-800">{item.total_price} ₾</td>
                </tr>
            ))
        )
        

        
    );
}